import React, {useContext, useState} from 'react';
import TextField from "@mui/material/TextField";
import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import {enums} from "../utils/enums";
import {createUserWithEmailAndPassword} from "firebase/auth";
import {auth, db} from "../utils/firebaseApp";
import {doc, setDoc} from "firebase/firestore";
import {toast} from "react-toastify";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import {AppContext} from "../utils/AppContext";
import {StorefrontOutlined} from "@mui/icons-material";

const AddStandModule = ({setOpenAddModal}) => {
    const [password, setPassword] = useState("");
    const [name, setName] = useState("");
    const [event, setEvent] = useState("");
    const {state: {stands, currentUser}, dispatch} = useContext(AppContext);

    console.log(currentUser)

    function createStand() {
        const standObject = {
            name: name,
            uid: crypto.randomUUID(),
            addedOn: Date.now(),
            eventUid: currentUser.event
        }

        setDoc(doc(db, "stands", standObject.uid), standObject)
            .then(r => {
                setName(null)
                stands.push(standObject)
                dispatch({stands: [...stands]})
                setOpenAddModal(false)

            }).catch(e => {
            console.log(e)
            toast.error('Adding failed, please try again')
        })
    }

    return (
        <>
            <Stack spacing={2}>
                <TextField
                    value={name}
                    onChange={e => setName(e.target.value)}
                    margin="normal"
                    required
                    id="name"
                    label="Name"
                    name="name"
                />

                <Button variant={'contained'} onClick={() => createStand()}>
                    <StorefrontOutlined sx={{marginRight: 1}}/> Dodaj štand
                </Button>
            </Stack>
        </>
    );
};

export default AddStandModule;
